import React, { useContext, useState, useEffect, useRef } from "react";
import "./Attendance.css";
import { EmplContext } from "../Login_Page/Login_Page/LoginPage";
import configData from "../../config.json";
import LoadingComponent from "../loading_component";
import { IoChevronBackOutline } from "react-icons/io5";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import eventEmitter from "../../Eventemitter";
import { useLocation } from "react-router-dom";

function Attendance({ sharedFunction, setSharedFunction }) {
  //new added 
  const [attachments, setAttachments] = useState([]);
  const handleAttachmentChange = (e) => {
    setAttachments([...e.target.files]); // supports multiple
  };
  //end
  const location = useLocation();
  const divRef = useRef(null);
  const { resultData } = useContext(EmplContext);
  const employee_id = resultData.employee_id || 0;
  const [Attendances, setAttendances] = useState([]);
  const [displayedAttendance, setDisplayedAttendance] = useState([]);
  const [attendanceCounts, setAttendanceCounts] = useState({
    leaveCount: 0.0,
    autoleaveCount: 0.0,
    presentCount: 0,
    absentCount: 0,
  });
  const [presentDaysData, setPresentDaysData] = useState([]);
  const [absentDaysData, setAbsentDaysData] = useState([]);
  const [leaveDaysData, setLeaveDaysData] = useState([]);
  const [autoleaveDaysData, setAutoleaveDaysData] = useState([]);
  const [showDaysData, setShowDaysData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("1");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [activeBox, setActiveBox] = useState(null);
  const [showFilter, setShowFilter] = useState(true);
  const [load, setLoading] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const [show, setShow] = useState(false);
  const [showleave, setShowLeave] = useState(false);
  const [leaves, setLeaves] = useState([]);
  const divRef_leave = useRef(null);
  const modalOpenedRef = useRef(false);
  const [formData, setFormData] = useState({
    remarks: "",
    reason: "",
    rec_id: "",
    is_yesterday_absent: "",
  });
  const [fetchexception, setFetchexception] = useState(false);

  const [showMachineModal, setShowMachineModal] = useState(false);
  const [selectedMachineData, setSelectedMachineData] = useState([]);
  const [selectedMachineDate, setSelectedMachineDate] = useState("");

  // Add function to handle machine details view
  const handleViewMachineDetails = (date, machineData) => {
    console.log("========== MACHINE LOG CLICK ==========", machineData);
    console.log("Date:", date);
    console.log("Machine Data:", machineData);
    console.log("Type:", typeof machineData);
    console.log("Is Array:", Array.isArray(machineData));
    // console.log("Viewing machine details for date:", date);
    // console.log("Machine data:", machineData);
    setSelectedMachineDate(date);
    setSelectedMachineData(machineData || []);
    setShowMachineModal(true);
  };

  // Machine Attendance Modal Component
  const MachineAttendanceModal = ({ date, machineData, onClose }) => {
    if (!machineData || machineData.length === 0) {
      return (
        <Modal show={true} onHide={onClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Machine Logs - {date}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-center text-muted">No machine logs available for this day.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      );
    }

    // Calculate totals
    const totals = machineData.reduce((acc, log) => {
      return {
        exit_hours: acc.exit_hours + (log.exit_hours || 0),
        worked_hours: acc.worked_hours + (log.worked_hours || 0),
        count: acc.count + 1
      };
    }, { exit_hours: 0, worked_hours: 0, count: 0 });


    // Helper function to convert decimal hours to HH:MM:SS format
    const formatHoursToHMS = (decimalHours) => {
      if (decimalHours === null || decimalHours === undefined || isNaN(decimalHours)) {
        return "00:00:00";
      }
      
      const totalSeconds = Math.floor(decimalHours * 3600);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    // Helper function to format decimal hours with both formats
    const formatHoursWithBoth = (decimalHours) => {
      const hms = formatHoursToHMS(decimalHours);
      const decimalStr = decimalHours.toFixed(2);
      return `${hms} (${decimalStr}h)`;
    };



    return (
      <Modal show={true} onHide={onClose} centered size="lg">
        <Modal.Header closeButton className="text-white">
          <Modal.Title>
            <i className="fas fa-server me-2"></i>
            Machine Logs - {date}
            <span className="badge bg-light text-dark ms-2">
              {machineData.length} records
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="machine-attendance-details">
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Check-in Time</th>
                    <th>Check-out Time</th>
                    <th>Exit Hours</th>
                    <th>Worked Hours</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {machineData.map((log, index) => (
                    <tr key={log.id || index} className={log.is_complete ? "table-success" : "table-warning"}>
                      <td className="text-center fw-bold">{index + 1}</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <i className="fas fa-sign-in-alt text-primary me-2"></i>
                          {log.check_in || '--:--'}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <i className="fas fa-sign-out-alt text-danger me-2"></i>
                          {log.check_out || '--:--'}
                        </div>
                      </td>
                      <td>
                        <span className="badge bg-secondary">
                          {log.exit_hours_display || formatHoursToHMS(log.exit_hours || 0)}
                        </span>
                        {/* 
                        <small className="text-muted d-block">
                          ({log.exit_hours ? log.exit_hours.toFixed(2) : '0.00'}h)
                        </small>
                        */}
                      </td>
                      <td>
                        <span className="badge bg-primary">
                          {log.worked_hours_display || formatHoursToHMS(log.worked_hours || 0)}
                        </span>
                        {/* 
                        <small className="text-muted d-block">
                          ({log.worked_hours ? log.worked_hours.toFixed(2) : '0.00'}h)
                        </small>
                        */}
                      </td>
                      <td>
                        <span className={`badge ${log.is_complete ? 'bg-success' : 'bg-warning'}`}>
                          <i className={`fas ${log.is_complete ? 'fa-check-circle' : 'fa-exclamation-triangle'} me-1`}></i>
                          {log.is_complete ? 'Complete' : 'Incomplete'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="">
                  <tr>
                    <td colSpan="3" className="text-end fw-bold">Totals:</td>
                    <td className="fw-bold">
                      <div>
                        <span className="badge bg-info me-2">
                          {formatHoursToHMS(totals.exit_hours)}
                        </span>
                        {/* 
                        <small className="text-muted">
                          ({totals.exit_hours.toFixed(2)}h)
                        </small>
                        */}
                      </div>
                    </td>
                    <td className="fw-bold">
                      <div>
                        <span className="badge bg-info me-2">
                          {formatHoursToHMS(totals.worked_hours)}
                        </span>

                        {/* 
                        <small className="text-muted">
                          ({totals.worked_hours.toFixed(2)}h)
                        </small>
                        */}
                      </div>
                    </td>
                    <td className="fw-bold">
                      <span className="badge bg-dark">
                        {totals.count} records
                      </span>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            
            {/* Summary Statistics */}
            <div className="row mt-3">
              <div className="col-md-6">
                <div className="card bg-light">
                  <div className="card-body">
                    <h6 className="card-title">
                      <i className="fas fa-chart-bar me-2"></i>
                      Daily Summary
                    </h6>
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-1"><small>Complete Records:</small></p>
                        <h5 className="text-success">
                          {machineData.filter(log => log.is_complete).length}
                        </h5>
                      </div>
                      <div className="col-6">
                        <p className="mb-1"><small>Incomplete Records:</small></p>
                        <h5 className="text-warning">
                          {machineData.filter(log => !log.is_complete).length}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card bg-light">
                  <div className="card-body">
                    <h6 className="card-title">
                      <i className="fas fa-clock me-2"></i>
                      Time Summary
                    </h6>
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-1"><small>Total Worked:</small></p>
                        <h5 className="text-primary">
                          {formatHoursToHMS(totals.worked_hours)}
                          <br />
                          {/* 
                          <small className="text-muted">
                            ({totals.worked_hours.toFixed(2)} hours)
                          </small>
                          */}
                        </h5>
                      </div>
                      <div className="col-6">
                        <p className="mb-1"><small>Total Exit:</small></p>
                        <h5 className="text-primary">
                          {formatHoursToHMS(totals.exit_hours)}
                          <br />
                          {/* 
                          <small className="text-muted">
                            ({totals.exit_hours.toFixed(2)} hours)
                          </small>
                           */}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            <i className="fas fa-times me-1"></i>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };




  const handleClose = () => {
    setShow(false);
    setShowLeave(false);
  };

  const handleShow = (row) => {
    setSelectedRow(row);
    setFormData({
      rec_id: row[0][2],
      is_yesterday_absent: row[0][7],
    });
    setShow(true);
  };

  const handleRaiseClick = (row) => {
    const isAbsent = row[0][7] === "True";
    if (isAbsent) {
      Swal.fire({
        title: "Raise Exception for Absent Leave?",
        text: "You cannot raise an exception for an absent day. Please confirm if there is any technical issue.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#875A7B",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirm, Raise Exception",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          handleShow(row);
        }
      });
    } else {
      handleShow(row);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    if (sharedFunction) {
      handleClick();
      setSharedFunction(null);
    }
  }, [sharedFunction, setSharedFunction]);

  const handleClick = () => {
    if (divRef.current) {
      divRef.current.click();
    }
  };

  useEffect(() => {
    setLoading(true);
  }, []);

  const handleBoxClick = (boxId) => {
    setActiveBox(boxId === activeBox ? null : boxId);
  };

  const fetchAttendance = async () => {
    // console.log("called")
    try {
      const secretKey = configData.SECRET_Key;
      const requestData = { employee_id, secretKey };
      const response = await fetch(`${configData.SERVER_URL}/myattendances`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      const result = JSON.parse(data.result);
      console.log("FULL API RESPONSE:", result);
      console.log("FIRST ATTENDANCE ROW:", result.attendance_yearly?.[0]);
      // console.log("result", result)
      if (result.success === true) {
        setAttendances(result.attendance_yearly);
        setLoading(false);
      }
      else{
        console.log("result ===", result);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    // Check if the user navigated to this page via the email link
    const params = new URLSearchParams(location.search);
    const fromEmail = params.get("fromEmail");
    const monthParam = params.get("month");
    const dateParam = params.get("date");

    // Existing behavior: auto-click Auto-Leave box
    if (fromEmail === "true") {
      // console.log("called emitter")
      // eventEmitter.emit("clickAutoleave");
      ClickAutoleave();
    }

    // New: If month is provided, set filter to show that month's data
    // month format: YYYY-MM (e.g., 2026-09)
    if (monthParam) {
      const [year, month] = monthParam.split("-").map(Number);
      if (year && month) {
        // Set filter to "range" and use custom range for the specified month
        setSelectedOption("range");
        const firstDay = new Date(year, month - 1, 1);
        const lastDay = new Date(year, month, 0);
        const formatDate = (d) => {
          const dd = String(d.getDate()).padStart(2, "0");
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const yyyy = d.getFullYear();
          return `${yyyy}-${mm}-${dd}`;
        };
        setDateFrom(formatDate(firstDay));
        setDateTo(formatDate(lastDay));
      }
    }

    // New: If date is provided, auto-open Raise Exception modal for that date
    // date format: DD-MM-YYYY (e.g., 12-09-2026)
    // Only open once when data is loaded (using ref to prevent multiple opens)
    if (dateParam && Attendances.length > 0 && !modalOpenedRef.current) {
      // Find the row whose attendance[0] matches the date
      const matchingRow = Attendances.find(
        (attendance) => attendance[0] === dateParam
      );
      if (matchingRow && matchingRow[7]) {
        // Auto-open the Raise Exception modal
        handleShow(matchingRow[7]);
        modalOpenedRef.current = true;
      }
    }
  }, [location, Attendances]);

  useEffect(() => {
    if (activeBox === null) {
      setShowDaysData([...displayedAttendance]);
    } else {
      switch (activeBox) {
        case "box1":
          setShowDaysData([...presentDaysData]);
          break;
        case "box2":
          setShowDaysData([...absentDaysData]);
          break;
        case "box3":
          setShowDaysData([...leaveDaysData]);
          break;
        case "box4":
          setShowDaysData([...autoleaveDaysData]);
          break;
        default:
          setShowDaysData([...displayedAttendance]);
          break;
      }
    }
  }, [
    activeBox,
    displayedAttendance,
    presentDaysData,
    absentDaysData,
    leaveDaysData,
    autoleaveDaysData,
  ]);

  // console.log("Attendances===========", Attendances);
  // console.log("showDaysData===========", showDaysData);
  // console.log("activeBox===========", activeBox);

  const shouldShowRaiseColumn = showDaysData.every(
    (leave) => leave[7].length !== 0
  );

  const Shouldremarksshown = showDaysData.every(
    // console.log("")
    (leave) => leave[7]?.[0]?.[4] === ""
  );

  // console.log("Shouldremarksshown=======",Shouldremarksshown)
  useEffect(() => {
    const autoleaverows = showDaysData.filter((leave) => leave[7].length !== 0);
    // console.log("autoleaverows===========", autoleaverows, typeof autoleaverows);
    const countRows = autoleaverows.filter((leave) => {
      // console.log("leave============",leave);
      return leave[7][0][3] === "Ex-draft" || leave[7][0][3] === "Ex-reject";
    }).length;
    // console.log("countRows===========", countRows, typeof countRows);
    eventEmitter.emit("countUpdated", countRows);
  }, [showDaysData]);

  const RaiseRequest = async (e) => {
    e.preventDefault();

    // console.log("ev ", e);
    if (fetchexception) return; // Prevent multiple requests

    setFetchexception(true); // Set fetchleave to true to indicate the request is in progress

    try {
      const secretKey = configData.SECRET_Key;
      const base64Files = await Promise.all(
        attachments.map(file =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () =>
              resolve({
                name: file.name,      // ✅ original filename
                data: reader.result,  // ✅ base64 data
              });
            reader.onerror = reject;
            reader.readAsDataURL(file);
          })
        )
      );
      // const requestData = { employee_id, secretKey, formData }; new added
      const requestData = { employee_id, secretKey, formData: {
        ...formData,
        attachment: base64Files,   // ✅ array of {name, data}
      }, };

      const response = await fetch(`${configData.SERVER_URL}/raiseRequest`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      const result = JSON.parse(data.result);
      // console.log("result", result);
      if (result.success === true) {
        // Swal.fire({
        //   icon: "success",
        //   title: result.message,
        // });
        // if (divRef_leave.current) {
        //   divRef_leave.current.click();
        // }
        window.location.reload();
      } else {
        Swal.fire({
          icon: "error",
          title: result.message,
        });
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      // fetchAttendance();
      setFetchexception(false); // Reset fetchleave to false after the request is completed
      setFormData({
        remarks: "",
        reason: "",
        rec_id: "",
      });
    }
  };

  function getFirstDateOfLastNMonths(n) {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() - n + 1;
    const date = 1;
    if (month <= 0) {
      return new Date(year - 1, 12 + month, date);
    } else {
      return new Date(year, month, date);
    }
  }




  function getAllCounts(displayedAttendance) {
    let newAttendanceCounts = {
      leaveCount: 0.0,
      autoleaveCount: 0.0,
      presentCount: 0.0,
      absentCount: 0.0,
    };

    if (displayedAttendance) {
      const presentData = [];
      const absentData = [];
      const leaveData = [];
      const autoleaveData = [];
      displayedAttendance.forEach((item) => {
        if (item[4] === "Present") {
          presentData.push(item);
          newAttendanceCounts.presentCount =
            newAttendanceCounts.presentCount + 1;
        }
        if (item[5] == "unapproved" || item[4] == "Absent") {
          absentData.push(item);
          newAttendanceCounts.absentCount =
            newAttendanceCounts.absentCount + item[6];
        }
        if (item[4] === "Leave" || item[4] == "Absent") {
          leaveData.push(item);
          newAttendanceCounts.leaveCount =
            newAttendanceCounts.leaveCount + item[6];
        }
        // if (item[4] === "Leave-Fullday") {
        //     leaveData.push(item);
        //     newAttendanceCounts.leaveCount = newAttendanceCounts.leaveCount + 1;
        // }
        // if (item[4] === "Autoleave-Halfday") {
        //     autoleaveData.push(item);
        //     newAttendanceCounts.autoleaveCount = newAttendanceCounts.autoleaveCount + 0.5;
        // }
        if (item[4] === "Autoleave") {
          autoleaveData.push(item);
          newAttendanceCounts.autoleaveCount =
            newAttendanceCounts.autoleaveCount + 1;
        }
      });
      setPresentDaysData(presentData);
      setAbsentDaysData(absentData);
      setLeaveDaysData(leaveData);
      setAutoleaveDaysData(autoleaveData);
    }

    setAttendanceCounts(newAttendanceCounts);
  }
  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    if (value === "range") {
    } else {
      // let FirstDateOfLastNplus1Months;
      let FirstDateOfLastNplus1Months = getFirstDateOfLastNMonths(1);
      let FirstDateOfLastNMonths;

      if (value === "3") {
        FirstDateOfLastNMonths = getFirstDateOfLastNMonths(4);
      } else if (value === "6") {
        FirstDateOfLastNMonths = getFirstDateOfLastNMonths(7);
      } else if (value === "2") {
        FirstDateOfLastNMonths = getFirstDateOfLastNMonths(value);
      } else if (value === "1") {
        FirstDateOfLastNMonths = getFirstDateOfLastNMonths(value);
        FirstDateOfLastNplus1Months = getFirstDateOfLastNMonths(value - 1);
      }
      const displayedAttendance = FirstDateOfLastNMonths
        ? Attendances.filter((attendance) => {
            const attendanceDateString = attendance[0];
            const [attendanceDay, attendanceMonth, attendanceYear] =
              attendanceDateString.split("-");
            const attendanceDate = new Date(
              `${attendanceMonth}-${attendanceDay}-${attendanceYear}`
            );
            return (
              attendanceDate >= FirstDateOfLastNMonths &&
              attendanceDate < FirstDateOfLastNplus1Months
            );
          })
        : Attendances;
      setDisplayedAttendance(displayedAttendance);
      getAllCounts(displayedAttendance);
      // console.log("displayedAttendance",displayedAttendance);
    }
  };



  useEffect(() => {
    fetchAttendance();
    // handleChange({ target: { value: selectedOption } });
  }, [employee_id]);

  useEffect(() => {
    if (Attendances.length > 0 && selectedOption === "1") {
      handleChange({ target: { value: "1" } });
    }
  }, [Attendances, selectedOption]);

  const handleSubmit = () => {
    // console.log("Date range submitted:", dateFrom, dateTo);
    if (dateFrom && dateTo) {
      const fromDate = new Date(dateFrom);
      fromDate.setHours(0, 0, 0, 0);
      const toDate = new Date(dateTo);
      // console.log("fromDate",fromDate)
      const filteredAttendance = Attendances.filter((attendance) => {
        const attendanceDateString = attendance[0];
        const [attendanceDay, attendanceMonth, attendanceYear] =
          attendanceDateString.split("-");
        const attendanceDate = new Date(
          `${attendanceMonth}-${attendanceDay}-${attendanceYear}`
        );
        // console.log("attendanceDate",attendanceDate)
        return attendanceDate >= fromDate && attendanceDate <= toDate;
      });
      setDisplayedAttendance(filteredAttendance);
      getAllCounts(filteredAttendance);
    }
  };

  const divRef_autoleave = useRef();

  const ClickAutoleave = () => {
    if (divRef_autoleave.current) {
      divRef_autoleave.current.click();
    }
  };

  useEffect(() => {
    const handleClickAutoleave = () => {
      ClickAutoleave();
    };

    eventEmitter.on("clickAutoleave", handleClickAutoleave);

    // Cleanup listener on component unmount
    return () => {
      eventEmitter.off("clickAutoleave", handleClickAutoleave);
    };
  }, []);

  function showFilterS() {
    setShowFilter(!showFilter);
  }

  // console.log("resultData.length", resultData.length)
  return (
    <>
      {load ? (
        <div className="main-panel">
          <LoadingComponent />
        </div>
      ) : (
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="ep_content">


              <div className="row">
                <div className="col-md-12">
                  <div className="das-filter">
                    <div className="das-filtitle" style={{ gap: "10px" }}>
                      {/* <IoChevronBackOutline
                        className="backbutton"
                        onClick={() => setActiveBox(null)}
                      /> */}
                      <div className="showFilter-btn" onClick={showFilterS}>
                        <img
                          src="filter.jpg"
                          style={{
                            height: 15,
                            margin: "7px 0px 10px 16px",
                          }}
                        />
                        <p
                          htmlFor="options"
                          style={{
                            marginBottom: "0px",
                            lineHeight: "29px",
                          }}
                        >
                          Filter
                        </p>
                      </div>
                    </div>
                    <div
                      className={`das-filtitle mt-3 ${
                        showFilter ? "show-filter" : ""
                      }`}
                    >
                      <div className="radio-option">
                        <input
                          type="radio"
                          id="currentMonth"
                          name="filterOption"
                          value="1"
                          checked={selectedOption === "1"}
                          onChange={handleChange}
                        />
                        <label htmlFor="currentMonth">Current Month</label>
                      </div>
                      <div className="radio-option">
                        <input
                          type="radio"
                          id="lastMonth"
                          name="filterOption"
                          value="2"
                          checked={selectedOption === "2"}
                          onChange={handleChange}
                        />
                        <label htmlFor="lastMonth">Last Month</label>
                      </div>
                      <div className="radio-option">
                        <input
                          type="radio"
                          id="lastThreeMonths"
                          name="filterOption"
                          value="3"
                          checked={selectedOption === "3"}
                          onChange={handleChange}
                        />
                        <label htmlFor="lastThreeMonths">Last 3 Months</label>
                      </div>
                      <div className="radio-option">
                        <input
                          type="radio"
                          id="lastSixMonths"
                          name="filterOption"
                          value="6"
                          checked={selectedOption === "6"}
                          onChange={handleChange}
                        />
                        <label htmlFor="lastSixMonths">Last 6 Months</label>
                      </div>
                      <div className="radio-option">
                        <input
                          type="radio"
                          id="customRange"
                          name="filterOption"
                          value="range"
                          checked={selectedOption === "range"}
                          onChange={handleChange}
                        />
                        <label htmlFor="customRange">Custom Range</label>
                      </div>
                    </div>
                    <div
                      className={`das-filtitle ${
                        showFilter ? "show-filter" : ""
                      }`}
                    >
                      {selectedOption === "range" && (
                        <div
                          className="mt-3"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <label htmlFor="dateFrom">Date From:</label>
                          <input
                            type="date"
                            id="dateFrom"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                            // onChange={handleDateFromChange}
                          />
                          <label htmlFor="dateTo">Date To:</label>
                          <input
                            type="date"
                            id="dateTo"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                            // onChange={handleDateToChange}
                          />
                          <button onClick={handleSubmit}>Submit</button>
                        </div>
                      )}
                    </div>
                    {/* <div className="das-lastm">
                                    {selectedOption && (
                                        <p>You selected: {getSelectedText(selectedOption)}</p>
                                    )}
                                </div> */}
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                      <div
                        className={`box ${
                          activeBox === "box1" ? "active" : ""
                        }`}
                        onClick={() => handleBoxClick("box1")}
                      >
                        <div className="dash-count das">
                          <div className="dash-counts">
                            <h4 className="dash-title">Present</h4>
                          </div>
                          <h4 className="dash-cunt dac">
                            {attendanceCounts.presentCount || 0}
                          </h4>
                          {/* <div className="dash-imgs">
                          </div> */}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                      <div
                        className={`box ${
                          activeBox === "box3" ? "active" : ""
                        }`}
                        onClick={() => handleBoxClick("box3")}
                        ref={divRef}
                      >
                        <div className="dash-count das2">
                          <div className="dash-counts">
                            <h4 className="dash-title">Leave</h4>
                          </div>
                          <div className="dash-imgs">
                            <h4 className="dash-cunt dac2">
                              {attendanceCounts.leaveCount || 0}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                      <div
                        className={`box ${
                          activeBox === "box2" ? "active" : ""
                        }`}
                        onClick={() => handleBoxClick("box2")}
                      >
                        <div className="dash-count das1">
                          <div className="dash-counts">
                            <h4 className="dash-title">UnApproved</h4>
                          </div>
                          <div className="dash-imgs">
                            <h4 className="dash-cunt dac1">
                              {attendanceCounts.absentCount || 0}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                      <div
                        className={`box ${
                          activeBox === "box4" ? "active" : ""
                        }`}
                        onClick={() => handleBoxClick("box4")}
                        ref={divRef_autoleave}
                      >
                        <div className="dash-count das3">
                          <div className="dash-counts">
                            <h4 className="dash-title">Auto-Leave</h4>
                          </div>
                          <div className="dash-imgs">
                            <h4 className="dash-cunt dac3">
                              {attendanceCounts.autoleaveCount || 0}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <div className="atable">
                      <table
                        id="basicTable"
                        // className="basic-table"
                        className={`basic-table ${
                          activeBox === "box2" || activeBox === "box3"
                            ? "table-mini"
                            : ""
                        }`}
                      >
                        {/* <colgroup>
                            <col style={{ width: 200 }} />
                            <col style={{ width: 200 }} />
                            <col style={{ width: 205 }} />
                            <col style={{ width: 200 }} />
                            <col style={{ width: 150 }} />
                        </colgroup> */}
                        <thead className="attendanceDataTableHead">
                          <tr
                            role="row"
                            //   style={{ background: "#14b49c" }}
                            className={`${
                              activeBox === null ? "allTypeData" : ""
                            } ${
                              activeBox === "box1" ? "presentTypeData" : ""
                            } ${activeBox === "box2" ? "absentTypeData" : ""} ${
                              activeBox === "box3" ? "leaveTypeData" : ""
                            } ${
                              activeBox === "box4" ? "autoLeaveTypeData" : ""
                            }`}
                          >
                            <th className="center">
                              <span> Date </span>
                              <span />
                            </th>
                            {activeBox === "box2" || activeBox === "box3" ? (
                              <></>
                            ) : (
                              <>
                                <th className="center">
                                  <span> Check-In </span>
                                  <span />
                                </th>
                                <th className="center">
                                  <span> Check-Out </span>
                                  <span />
                                </th>
                                <th className="center" width="200px">
                                  <span> Working Hours </span>
                                  <span />
                                </th>
                                <th className="center">
                                  <span> Out Hours </span>
                                  <span />
                                </th>
                                <th className="center" width="200px">
                                  <span> Productive Hours </span>
                                  <span />
                                </th>
                                <th className="center">
                                  <span> Tags </span>
                                  <span />
                                </th>

                                {/* Add Machine Details column */}
                                <th className="center">
                                  <span> Machine Logs </span>
                                  <span />
                                </th>


                              </>
                            )}

                            <th className="center">
                              <span> Status </span>
                              <span />
                            </th>
                            {shouldShowRaiseColumn && (
                              <>
                                <th className="center">
                                  <span> Raise </span>
                                  <span />
                                </th>
                                {!Shouldremarksshown && (
                                  <>
                                    <th className="center">
                                      <span>Raise Reason </span>
                                      <span />
                                    </th>
                                    <th className="center">
                                      <span>Manager Remarks </span>
                                      <span />
                                    </th>
                                  </>
                                )}
                              </>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {showDaysData.slice().reverse().map((attendance, index) => (
                            <tr
                              key={index}
                              className={`${
                                activeBox === null ? "allTypeData" : ""
                              } ${
                                activeBox === "box1" ? "presentTypeData" : ""
                              } ${
                                activeBox === "box2" ? "absentTypeData" : ""
                              } ${
                                activeBox === "box3" ? "leaveTypeData" : ""
                              } ${
                                activeBox === "box4" ? "autoLeaveTypeData" : ""
                              }`}
                            >
                              <td> {attendance[0]}</td>
                              {activeBox === "box2" || activeBox === "box3" ? (
                                <></>
                              ) : (
                                <>
                                  <td> {attendance[1] || "- -"}</td>
                                  <td> {attendance[2] || "- -"}</td>
                                  <td> {attendance[3] || "- -"} </td>
                                  <td> {attendance[8] || "- -"} </td>
                                  <td> {attendance[9] || "- -"} </td>
                                  <td> {attendance[10] || "- -"} </td>


                                  {/* Machine Details Button */}
                                  <td>
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        console.log("Current attendance row:", attendance);
                                        console.log("attendance[11]:", attendance[11]);
                                        handleViewMachineDetails(attendance[0], attendance[11] || attendance[12]);
                                      }}
                                      className="btn btn-sm btn-info"
                                      title="View Machine Logs"
                                    >
                                      <i className="fas fa-server me-1"></i>
                                      View Details
                                      {attendance[11] && attendance[11].length > 0 && (
                                        <span className="badge bg-light text-dark ms-1">
                                          {attendance[11].length}
                                        </span>
                                      )}
                                    </button>
                                  </td>

                                  
                                </>
                              )}

                              <td className="attendance-tags">
                                <span
                                  // className={` ${attendance[4] === '' ? 'tag-Weekend' : ''}`}
                                  className={` ${
                                    attendance[4].startsWith("Leave")
                                      ? attendance[5].startsWith("approved")
                                        ? "tag-Leave"
                                        : attendance[5].startsWith("pending")
                                        ? "tag-leave-pending"
                                        : "tag-leave-unapporved"
                                      : attendance[4].startsWith("Autoleave")
                                      ? "tag-AutoLeave"
                                      : attendance[4] === "Present"
                                      ? "tag-Present"
                                      : attendance[4] === "Holiday"
                                      ? "tag-Holiday"
                                      : attendance[4] === "holiday-rh"
                                      ? "tag-Holiday"
                                      : attendance[4] === "Absent"
                                      ? "tag-leave-unapporved"
                                      : "tag-Weekend"
                                  }`}
                                >
                                  {attendance[4]
                                    ? `${attendance[4]} ${attendance[5]}`
                                    : "Weekend"}
                                </span>
                              </td>
                              {/* {shouldShowRaiseColumn && (
                                <td>
                                  {" "}
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleShow(attendance[7]);
                                    }}
                                    className="btn btn-primary"
                                  >
                                    Raise
                                  </button>
                                </td>
                              )} */}
                              {shouldShowRaiseColumn && (
                                <>
                                  {/* <td> {attendance[7][0][6] || "- -"} </td> */}
                                  <td>
                                    {(() => {
                                      //  console.log("FULL attendance row:", attendance);
                                      // console.log("attendance[7]:", attendance[7]);
                                      // console.log("attendance[7][0]:", attendance[7]?.[0]);
                                      // console.log("exception status:", attendance[7]?.[0]?.[3]);
                                      // console.log("hide flag raw:", attendance[7]?.[0]?.[6]);
                                      // console.log("hide flag type:", typeof attendance[7]?.[0]?.[6]);
                                      const exceptionStatus = attendance[7][0][3];
                                      const hideRaise = attendance[7][0][6] === true;

                                      if (!hideRaise && (exceptionStatus === "Ex-draft" || exceptionStatus === "Ex-reject")) {
                                        return (
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleRaiseClick(attendance[7]);
                                            }}
                                            className="btn btn-primary"
                                          >
                                            Raise
                                          </button>
                                        );
                                      }

                                      if (exceptionStatus === "Ex-raised") {
                                        return <span className="exception-raised op_p">Exception raised</span>;
                                      }

                                      if (exceptionStatus === "Ex-approved") {
                                        return <span className="exception-approved op_a">Exception approved</span>;
                                      }

                                      return null;
                                    })()}
                                  </td>

                                  {!Shouldremarksshown && (
                                    <>
                                      <td>{attendance[7][0][4]}</td>
                                      <td>{attendance[7][0][5]}</td>
                                    </>
                                  )}
                                </>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      
                      <form className="raise-request-form">
                        <Modal
                          show={show}
                          onHide={handleClose}
                          backdrop="static"
                          keyboard={false}
                          centered
                          className="raise-request-modal"
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Raise Request</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="raise-request-form">
                              <div className="form-left">
                                <div className="form-group">
                                  <label htmlFor="request-name">Name</label>
                                  <input
                                    id="request-name"
                                    type="text"
                                    name="name"
                                    value={selectedRow ? selectedRow[0][0] : ""}
                                    readOnly
                                  />
                                </div>

                                <div className="form-group">
                                  <label htmlFor="request-desp">
                                    Description
                                  </label>
                                  <textarea
                                    id="request-desp"
                                    type="text"
                                    name="description"
                                    value={selectedRow ? selectedRow[0][1] : ""}
                                    readOnly
                                    rows="3"
                                  />
                                </div>

                                <div className="form-group">
                                  <label htmlFor="request-attachment">Attachment</label>
                                  <input
                                    type="file"
                                    id="request-attachment"
                                    name="attachment"
                                    accept=".pdf, image/*"
                                    multiple
                                    onChange={handleAttachmentChange}
                                  />
                                </div>
                                
                              </div>

                              <div className="form-right">
                                <div className="form-group">
                                  <label htmlFor="request-reason">Reason</label>
                                  <select
                                    id="request-reason"
                                    name="reason"
                                    value={formData.reason}
                                    onChange={handleInputChange}
                                  >
                                    <option value=""></option>
                                    <option value="technical-issue">
                                      Technical Issue
                                    </option>
                                    <option value="planned-meetings">
                                      Planned Meetings(externals)
                                    </option>
                                    <option value="others">Others</option>
                                  </select>
                                </div>

                                <div className="form-group">
                                  <label htmlFor="request-remarks">
                                    Remarks
                                  </label>
                                  <textarea
                                    id="request-remarks"
                                    type="text"
                                    name="remarks"
                                    value={formData.remarks || ""}
                                    onChange={handleInputChange}
                                    rows="3"
                                  />
                                </div>
                              </div>
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              ref={divRef_leave}
                              variant="secondary"
                              onClick={handleClose}
                            >
                              Discard
                            </Button>
                            <Button variant="primary" onClick={RaiseRequest}>
                              Raise
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </form>


                      {/* Machine Attendance Modal */}
                      {showMachineModal && (
                        <MachineAttendanceModal
                          date={selectedMachineDate}
                          machineData={selectedMachineData}
                          onClose={() => setShowMachineModal(false)}
                        />
                      )}

                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Attendance;